var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDatabase, faEyeSlash, faHdd, faMapMarker, faSync, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BButtonGroup, BModal } from "bootstrap-vue";
import { formatDistanceToNowStrict } from "date-fns";
import { storeToRefs } from "pinia";
import prettyBytes from "pretty-bytes";
import { computed, onMounted, ref, toRef } from "vue";
import { useRouter } from "vue-router/composables";
import { userOwnsHistory } from "@/api";
import { HistoryFilters } from "@/components/History/HistoryFilters.js";
import { useConfig } from "@/composables/config";
import { useHistoryContentStats } from "@/composables/historyContentStats";
import { useStorageLocationConfiguration } from "@/composables/storageLocation";
import { useUserStore } from "@/stores/userStore";
import PreferredStorePopover from "./PreferredStorePopover.vue";
import SelectPreferredStore from "./SelectPreferredStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryCounter',
    props: {
        history: null,
        isWatching: { type: Boolean, default: false },
        lastChecked: { default: () => new Date() },
        filterText: { default: "" },
        showControls: { type: Boolean, default: false },
        hideReload: { type: Boolean, default: false }
    },
    emits: ["update:filter-text", "reloadContents"],
    setup(__props, { emit }) {
        const props = __props;
        const { isOnlyPreference } = useStorageLocationConfiguration();
        library.add(faDatabase, faEyeSlash, faHdd, faMapMarker, faSync, faTrash);
        const router = useRouter();
        const { config } = useConfig();
        const { currentUser, isAnonymous } = storeToRefs(useUserStore());
        const { historySize, numItemsActive, numItemsDeleted, numItemsHidden } = useHistoryContentStats(toRef(props, "history"));
        const reloadButtonLoading = ref(false);
        const reloadButtonTitle = ref("");
        const reloadButtonVariant = ref("link");
        const showPreferredObjectStoreModal = ref(false);
        const historyPreferredObjectStoreId = ref(props.history.preferred_object_store_id);
        const niceHistorySize = computed(() => prettyBytes(historySize.value));
        const storageLocationTitle = computed(() => {
            if (isOnlyPreference.value) {
                return "History Preferred Storage Location";
            }
            else {
                return "History Storage Location";
            }
        });
        function onDashboard() {
            router.push({ name: "HistoryOverviewInAnalysis", params: { historyId: props.history.id } });
        }
        function setFilter(filter) {
            let newFilterText = "";
            let settings = {};
            if (filter == "") {
                settings = {
                    deleted: false,
                    visible: true,
                };
            }
            else {
                const newVal = getCurrentFilterVal(filter) === "any" ? HistoryFilters.defaultFilters[filter] : "any";
                settings = {
                    deleted: filter === "deleted" ? newVal : getCurrentFilterVal("deleted"),
                    visible: filter === "visible" ? newVal : getCurrentFilterVal("visible"),
                };
            }
            newFilterText = HistoryFilters.applyFiltersToText(settings, props.filterText);
            emit("update:filter-text", newFilterText);
        }
        function getCurrentFilterVal(filter) {
            return HistoryFilters.getFilterValue(props.filterText, filter);
        }
        function updateTime() {
            const diffToNow = formatDistanceToNowStrict(props.lastChecked, { addSuffix: true });
            const diffToNowSec = Date.now().valueOf() - props.lastChecked.valueOf();
            // if history isn't being watched or hasn't been watched/polled for over 2 minutes
            if (!props.isWatching || diffToNowSec > 120000) {
                reloadButtonTitle.value = "Last refreshed " + diffToNow + ". Consider reloading the page.";
                reloadButtonVariant.value = "danger";
            }
            else {
                reloadButtonTitle.value = "Last refreshed " + diffToNow;
                reloadButtonVariant.value = "link";
            }
        }
        function reloadContents() {
            return __awaiter(this, void 0, void 0, function* () {
                emit("reloadContents");
                reloadButtonLoading.value = true;
                setTimeout(() => {
                    reloadButtonLoading.value = false;
                }, 1000);
            });
        }
        function onUpdatePreferredObjectStoreId(preferredObjectStoreId) {
            showPreferredObjectStoreModal.value = false;
            // ideally this would be pushed back to the history object somehow
            // and tracked there... but for now this is only component using
            // this information.
            historyPreferredObjectStoreId.value = preferredObjectStoreId;
        }
        onMounted(() => {
            updateTime();
            // update every second
            setInterval(updateTime, 1000);
        });
        return { __sfc: true, isOnlyPreference, props, emit, router, config, currentUser, isAnonymous, historySize, numItemsActive, numItemsDeleted, numItemsHidden, reloadButtonLoading, reloadButtonTitle, reloadButtonVariant, showPreferredObjectStoreModal, historyPreferredObjectStoreId, niceHistorySize, storageLocationTitle, onDashboard, setFilter, getCurrentFilterVal, updateTime, reloadContents, onUpdatePreferredObjectStoreId, faDatabase, faEyeSlash, faHdd, faMapMarker, faSync, faTrash, FontAwesomeIcon, BButton, BButtonGroup, BModal, userOwnsHistory, PreferredStorePopover, SelectPreferredStore };
    }
});
